module.exports = __webpack_public_path__ + "static/media/53.8f77e4e0.jpg";